import { rentacarPalette } from "Theme/palette"

export const TABLE_TAB_SELECTED = {
	MIN: 'min',
	MAX: 'max',
}

export const CHART_OPTIONS = {
	BY_PRICE: 'price',
	BY_DIFF: 'diff',
}

// The main brand is drawn in the app blue across both position charts, so its
// line and its tooltip entry stand out from the backend-assigned series colors.
export const POSITION_MAIN_COLOR = rentacarPalette.primary.main

export const SECTIONS = {
	BROKERS: 'brokers',
	DIRECT_SITE: 'directSite',
	LOR: 'lor',
	DOR: 'dor',
	RATING: 'rating',
	POSITION: 'position',
}